import axios from "axios"
import { isNil } from "lodash/fp"
import log from "loglevel"
import { inspect } from "./inspect"
import { httpRequest } from "../../functions/common"

log.setLevel(log.levels.DEBUG)

const env = process.env['REACT_APP_ENV'] ?? 'dev'


const baseName = 'miraiz-connect.jp'
const zoneName = `${{ prd: '', stg: '', int: 'dev.', dev: 'dev.', exp: 'dev.' }[env] as string
    }${baseName}`
const domainName = `api${{ prd: '', stg: '-stg', int: '-int', dev: '', exp: '-exp' }[env] as string
    }.form-builder.${zoneName}`

export const sendRequestData = async (data: any): Promise<boolean> => {
    const result = await httpRequest('POST', `https://${domainName}/v1/request/send-request`, data)
    if (isNil(result) || result.status !== 200) {
        return false
    }
    log.error(`[functions.sendRequestData]`, inspect(result))
    return true
}

